import { Component, OnInit } from '@angular/core';
import { ServiceLocatorService } from '@ncs/ncs-lib';
import { SharedataService } from '../common/service/sharedata.service';

@Component({
  selector: 'app-theme-customizer',
  templateUrl: './theme-customizer.component.html',
  styleUrls: ['./theme-customizer.component.css'],
})
export class ThemeCustomizerComponent implements OnInit {
  keySuffix: any;
  selectedTheme: any = 'lightmode';

  constructor(
    public locator: ServiceLocatorService,
    private sharedata: SharedataService,
  ) {
    this.subscribeToData();
    // this.sharedata.setFunction('sidebar', this.applySidebarColor);
    this.keySuffix = localStorage.getItem('keySuffix');
  }

  subscribeToData() {
    this.sharedata.getData().subscribe({
      next: (data: any) => {
        this.selectedTheme = data['data'];
      },
      error: (err) => console.error('Error:', err),
    });
  }

  sidebarColors = [
    'sidebarcolor1',
    'sidebarcolor2',
    'sidebarcolor3',
    'sidebarcolor4',
    'sidebarcolor5',
    'sidebarcolor6',
    'sidebarcolor7',
    'sidebarcolor8',
  ];
  headerColors = [
    'headercolor1',
    'headercolor2',
    'headercolor3',
    'headercolor4',
    'headercolor5',
    'headercolor6',
    'headercolor7',
    'headercolor8',
  ];

  switcherOpen = false;
  toggleSwitcher() {
    this.switcherOpen = !this.switcherOpen;
  }

  applyTheme(theme: string) {
    localStorage.removeItem(this.keySuffix + 'selectedSidebarColor');
    localStorage.setItem(this.keySuffix + 'theme', theme);
    const fn = this.sharedata.getFunction('toggle');

    if (fn) {
      if (theme == 'lightmode') {
        this.sharedata.sendData('lightmode');
        fn('lightmode');
      } else if (theme == 'darkmode') {
        this.sharedata.sendData('darkmode');
        fn('darkmode');
      } else if (theme == 'semidark') {
        this.sharedata.sendData('semidark');
        fn('semidark');
      }
    }
  }

  applySidebarColor(color: string) {
    const index = this.sidebarColors.indexOf(color);
    let headerColor = this.headerColors[index];

    localStorage.setItem(
      this.keySuffix + 'selectedSidebarColor',
      this.sidebarColors[index],
    );

    // Read from localStorage directly — always reflects true current theme
    const currentTheme = localStorage.getItem(this.keySuffix + 'theme');
    let themeClass = '';
    if (currentTheme === 'darkmode') themeClass = 'dark-theme';
    else if (currentTheme === 'semidark') themeClass = 'semi-dark';

    document.documentElement.setAttribute(
      'class',
      `color-header color-sidebar ${color} ${headerColor} ${themeClass}`.trim(),
    );
  }

  loadStoredSidebarColor() {
    const currentUrl = window.location.href;
    const isAuthPage = [
      '/login',
      '/signup',
      '/forgotpassword',
      '/signupInvitation',
    ].some((path) => currentUrl.includes(path));
    if (isAuthPage) return; // ← skip theme restore on auth pages

    const storedTheme = localStorage.getItem(this.keySuffix + 'theme');

    let themeClass = '';
    if (storedTheme === 'darkmode') themeClass = 'dark-theme';
    else if (storedTheme === 'semidark') themeClass = 'semi-dark';
    else themeClass = 'light-theme';

    // Always clear sidebar color on refresh and restore theme only
    localStorage.removeItem(this.keySuffix + 'selectedSidebarColor');
    document.documentElement.setAttribute('class', themeClass);

    // ✅ ADD THESE — restore CSS variables too
    if (storedTheme === 'darkmode') {
      document.documentElement.style.setProperty('--primary-color', '#12181a');
      document.documentElement.style.setProperty(
        '--secondary-color',
        '#f1f1f1',
      );
    } else if (storedTheme === 'semidark') {
      document.documentElement.style.setProperty('--primary-color', '#fff');
      document.documentElement.style.setProperty(
        '--secondary-color',
        '#5f5f5f',
      );
    } else {
      document.documentElement.style.setProperty('--primary-color', '#fff');
      document.documentElement.style.setProperty(
        '--secondary-color',
        '#5f5f5f',
      );
    }
  }

  applyHeaderColor(color: string) {
    document.documentElement.setAttribute('class', `color-header ${color}`);
  }

  ngOnInit() {
    this.selectedTheme =
      localStorage.getItem(this.keySuffix + 'theme') || 'lightmode';
    this.loadStoredSidebarColor();
  }
}
